import { commonBase } from '@kid/meta-color/color/output/all';
import { useStyle } from '../../hooks/useStyle';
export function useTagStyle() {
    const tagStyle = useStyle({
        base: {
            alignSelf: 'baseline',
            paddingVertical: 2,
            paddingHorizontal: 4,
            borderRadius: 2.5,
            // lineHeight: 14,
            alignItems: 'center',
            justifyContent: 'center',
        },
        textBase: {
            lineHeight: 14,
            fontSize: 12,
        },
        default: {
            color: commonBase.kiui_color_base_black_1_a64,
        },
        primary: {
            color: commonBase.kiui_color_base_red_1,
        },
        ghost: {
            color: commonBase.kiui_color_base_red_1,
        },
        linearGradient: {
            height: 18,
            borderTopLeftRadius: 3,
            borderBottomLeftRadius: 3,
            borderBottomEndRadius: 3,
            flexDirection: 'row',
            alignItems: 'center',
            paddingHorizontal: 4,
            paddingRight: 8,
            paddingVertical: 3,
        },
        flashLeftText: {
            color: commonBase.kiui_color_base_white_1,
            fontSize: 11,
            lineHeight: 12,
        },
        flashIconBox: {
            position: 'relative',
            alignItems: 'center',
            height: 18,
        },
        flashIcon: {
            position: 'absolute',
            top: 0,
            right: -8,
            height: 18,
            width: 12,
        },
        flashRight: {
            height: 18,
            paddingLeft: 12,
            paddingRight: 4,
            fontSize: 11,
            lineHeight: 18,
            alignItems: 'center',
            borderTopRightRadius: 3,
            borderBottomRightRadius: 3,
            backgroundColor: commonBase.kiui_color_base_red_1_a12,
        },
        flashRightText: {
            color: commonBase.kiui_color_base_red_1,
        },
    });
    const boxStyle = useStyle({
        default: {
            backgroundColor: commonBase.kiui_color_base_black_21_a24,
        },
        primary: {
            backgroundColor: commonBase.kiui_color_base_red_1_a12,
        },
        ghost: {
            paddingVertical: 1,
            borderWidth: 1,
            borderColor: commonBase.kiui_color_base_red_2_a12,
        },
    });
    return {
        tagStyle,
        boxStyle,
    };
}
